// Copyright 2025 Sorama B.V.
import chmln from "@chamaeleonidae/chmln";
import { WorkflowTourCatalog } from "catalogs/WorkflowTourCatalog";

export class ChameleonTour {
    public getChameleonTour(tourName: string) {
        const tour = WorkflowTourCatalog[tourName];

        if (!tour?.chmlnId) return false;
        return chmln.show(tour.chmlnId);
    }
}
